// utils/errorHandler.js
import { toast } from "react-toastify";

export const handleApiError = (err, fallbackMessage = "Ocurrió un error") => {
  if (!err?.response) {
    toast.error("No responde el servidor");
    return;
  }

  if (err.response.status === 422) {
    const errors = err.response.data;

    Object.entries(errors).forEach(([field, messages]) => {
      (Array.isArray(messages) ? messages : [messages]).forEach((msg) => {
        toast.error(`${msg}`);
      });
    });
  } else {
    toast.error(
      err.response?.data?.error || err.response?.data?.message || fallbackMessage
    );
  }
};
